import '../assets/styles/Skeleton.css';

const SkeletonLoader = ({ height, width}) => {
    return <span className={"skeleton-loader " +( width ? width : "w-25")} style={{ height: height }}></span>;
  };
  
  export default SkeletonLoader;